import React from 'react';
import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { isAzureAdConfigured, loginRequest } from '../../auth/msalConfig';
import { LoadingSpinner } from '../common/LoadingSpinner';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

// Renders children only when the user is authenticated. When Azure AD is not
// configured (local dev with empty .env), auth is bypassed entirely.
//
// When AD is configured, MsalAuthenticationTemplate auto-triggers a redirect to
// Microsoft sign-in for unauthenticated users — no explicit login page is needed.
// Users with an active Microsoft session sign in transparently (true SSO).
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  if (!isAzureAdConfigured) {
    return <>{children}</>;
  }

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={loginRequest}
      loadingComponent={() => <LoadingSpinner message="Signing in..." />}
      errorComponent={({ error }) => (
        <div className="p-6 text-sm text-red-700 dark:text-red-300">
          Sign-in failed: {error?.errorMessage ?? 'Unknown error'}
        </div>
      )}
    >
      <>{children}</>
    </MsalAuthenticationTemplate>
  );
};
